import React from "react";
import Drawer from "../../../../Components/UI/Drawer/Drawer";
import { Outlet, useLoaderData } from "react-router";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";

import ArticleIcon from "@mui/icons-material/Article";
import { useParams } from "react-router-dom";
import { ClientPaymentContextProvider } from "Context/ClientPayment";

export function ClientPaymentPage() {
  const { paymentID } = useParams();
  return (
    <ClientPaymentContextProvider clientPaymentId={paymentID}>
      <Box component="main" sx={{ flexGrow: 1, overflow: "auto" }}>
        <Box sx={{ flexGrow: 1, p: 3 }}>
          <Typography variant="h5" gutterBottom>
            {"Klientutbetalning - "}
            {paymentID}
          </Typography>
          <Outlet />
        </Box>
      </Box>
    </ClientPaymentContextProvider>
  );
}
